(function() {
    angular.module('GorillaBoy.services')
    .factory('SearchV2Service', ['$routeParams', '$http', '$log', 'SessionManager', 'EndpointService', 'AppConstants', 'SortService',
        function($routeParams, $http, $log, SessionManager, EndpointService, AppConstants, SortService) {

        // AppConstant bindings
        var httpMethods = AppConstants.HttpMethods;

        var searchV2Service = {};

        searchV2Service.searchResources = function (queryString, sortOption, advanceOptions, marker, limit) {
            var searchText = queryString? queryString : undefined;
            var field = (sortOption.orderBy)? sortOption.orderBy : "RELEVANCE";
            var order = (sortOption.order && sortOption.order == SortService.CONSTANTS.ORDER.ASCENDING)? 'ASC' : 'DESC';

            var postData = {
                OrderBy: {
                    Field: field,
                    Order: order
                },
                Types: advanceOptions.Types,
                ContentMimeTypes: advanceOptions.ContentMimeTypes,
                AncestorIds: advanceOptions.AncestorIds,
                OwnerIds: advanceOptions.OwnerIds,
                ModifiedTimestampRange: advanceOptions.ModifiedTimestampRange,
                CreatedTimestampRange: advanceOptions.CreatedTimestampRange,
                CreatorIds: advanceOptions.CreatorIds,
                ModifierIds: advanceOptions.ModifierIds,
                SharedWithMe: advanceOptions.SharedWithMe,
                SharedByMe: advanceOptions.SharedByMe,
                Marker: marker,
                Limit: limit
            };

            if (!advanceOptions.SearchInName && !advanceOptions.SearchInContent &&
                !advanceOptions.SearchInComments && !advanceOptions.SearchInLabels) {

                postData.FullText = searchText;
                postData.TextLocale = advanceOptions.TextLocale;

            } else {
                if (advanceOptions.SearchInName) {
                    postData.Name = searchText;
                }
                if (advanceOptions.SearchInContent) {
                    postData.Content = searchText;
                    postData.TextLocale = advanceOptions.TextLocale;
                }
                if (advanceOptions.SearchInComments) {
                    postData.Comments = searchText;
                }
                if (advanceOptions.SearchInLabels) {
                    postData.Label = searchText;
                }
            }

            var config = {
                url: EndpointService.endpoint(true) + 'searchV2/',
                method: httpMethods.POST,
                data: postData
            };

            return $http(EndpointService.tokenize(config));
        };

        return searchV2Service;
    }]);
}());
